import _ from "i18n";

export const APP_ENV = process.env.REACT_APP_APP_ENV;
export const TTP_API_URL = process.env.REACT_APP_TTP_API_URL;
export const TTP_MEDIA_URL = process.env.REACT_APP_TTP_MEDIA_URL;
export const TTP_BLOG_URL = process.env.REACT_APP_TTP_BLOG_URL;
export const TTP_FLUX_URL = process.env.REACT_APP_TTP_FLUX_URL;
export const TTP_EVENT_URL = process.env.REACT_APP_TTP_EVENT_URL;
export const TTP_EMAILING_URL = process.env.REACT_APP_TTP_EMAILING_URL;
export const TTP_HOME_URL = process.env.REACT_APP_TTP_HOME_URL;
export const TTP_SURVEY_URL = process.env.REACT_APP_TTP_SURVEY_URL;
export const TTP_TALK_URL = process.env.REACT_APP_TTP_TALK_URL;
export const TTP_DASHBOARD_URL = process.env.REACT_APP_TTP_DASHBOARD_URL;
export const TTP_PORTAL_URL = process.env.REACT_APP_TTP_PORTAL_URL;
export const TTP_POWER_TEAM_URL = process.env.REACT_APP_TTP_POWER_TEAM_URL;
export const TTP_UA_URL = process.env.REACT_APP_TTP_UA_URL;

export const S3_FOLDER_URL_PROD = "https://s3.tamtam.pro/prod";

export const TTP_LOGO_URL = "/img/logo.svg";

export const AUTH_COOKIE_NAME = `ttp_auth${
  APP_ENV !== "" ? "_" : ""
}${APP_ENV}`;

export const URL_HASH_KEY = "Y3YZVA6uSLVqJhAWHdsb9CsGgcBXIhmY";

export const COMMUNITY_NAME_MAX_LENGTH = 20;
export const COMMUNITY_DEFAULT_LOGO_URL = "/img/default-logo.png";

export const MENUS = {
  /* GUEST: ["CLIENTS"],
  ADMIN: ["COMMUNITIES", "CLIENTS"],
  EDITOR: ["COMMUNITIES", "CLIENTS"],
  USER: ["COMMUNITIES", "CLIENTS"]*/
  GUEST: ["CLIENTS"],
  ADMIN: ["COMMUNITIES", "CLIENTS"],
  MANAGER: ["CLIENTS"],
  COLLABORATOR: ["CLIENTS"],
  SUPERVISOR: ["CLIENTS"],
  USER: ["CLIENTS"]
};

export const DIALOG_TYPES = {
  PRIMARY: "primary",
  SUCCESS: "success",
  ALERT: "alert"
};

export const VERTICAL = "VERTICAL";
export const HORIZONTAL = "HORIZONTAL";

export const PAGES = {
  HOME_PAGE: "HOME_PAGE",
  COMMUNITIES_PAGE: "COMMUNITIES_PAGE",
  SETTING_PAGE: "SETTING_PAGE",
  CLIENTS_LIST: "CLIENTS_LIST",
  BALANCE_SHEET_PAGE: "BALANCE_SHEET_PAGE",
  DASHBOARD_PAGE: "DASHBOARD_PAGE",
  DIAPORAMA_PAGE: "DIAPORAMA_PAGE",
  DASHBOARD_PAGE_COMPOSITION: "DASHBOARD_PAGE_COMPOSITION",
  PREPARE_PRESENTATION_PAGE: "PREPARE_PRESENTATION_PAGE",
  PRESENTATION_PAGE: "PRESENTATION_PAGE"
};

export const HIDDEN_MENU_PAGES = [
  "DASHBOARD_PAGE_COMPOSITION",
  "PREPARE_PRESENTATION_PAGE",
  "PRESENTATION_PAGE"
];

export const SOCIAL_NETWORKS_HOSTS = {
  FACEBOOK: "https://www.facebook.com",
  TWITTER: "https://www.twitter.com",
  LINKEDIN: "https://www.linkedin.com"
};

export const COMMENTS = {
  collaborator: [
    [
      "badPerformancesCollaborator1",
      "badPerformancesCollaborator2",
      "badPerformancesCollaborator3",
      "badPerformancesCollaborator4"
    ],
    [
      "passablePerformancesCollaborator1",
      "passablePerformancesCollaborator2",
      "passablePerformancesCollaborator3",
      "passablePerformancesCollaborator4"
    ],
    [
      "goodPerformancesCollaborator1",
      "goodPerformancesCollaborator2",
      "goodPerformancesCollaborator3",
      "goodPerformancesCollaborator4"
    ],
    [
      "greatPerformancesCollaborator1",
      "greatPerformancesCollaborator2",
      "greatPerformancesCollaborator3",
      "greatPerformancesCollaborator4"
    ]
  ],
  organization: [
    [
      "badPerformancesOrganization1",
      "badPerformancesOrganization2",
      "badPerformancesOrganization3",
      "badPerformancesOrganization4"
    ],
    [
      "passablePerformancesOrganization1",
      "passablePerformancesOrganization2",
      "passablePerformancesOrganization3",
      "passablePerformancesOrganization4"
    ],
    [
      "goodPerformancesOrganization1",
      "goodPerformancesOrganization2",
      "goodPerformancesOrganization3",
      "goodPerformancesOrganization4"
    ],
    [
      "greatPerformancesOrganization1",
      "greatPerformancesOrganization2",
      "greatPerformancesOrganization3",
      "greatPerformancesOrganization4"
    ]
  ]
};

export const SVG_ICONS = {
  //MainMenu
  PROFILE: "profile.svg",
  PORTAL: "portal.svg",
  NOTIFS: "notifs.svg",
  APPS: "apps.svg",
  EBOX: "ebox.svg",

  //icons
  TARGET: "target.svg",
  MONEY_BAG: "money-bag.svg",
  PIG: "pig.svg",
  WALLET: "wallet.svg",
  PIECES: "pieces.svg"
};

export const ORGANIZATION_STATUS = {
  INITIAL: "INITIAL",
  ACTIVATED: "ACTIVATED",
  NOT_ACTIVATED: "NOT_ACTIVATED",
  PENDING: "PENDING"
};

export const LIST_PAGE_SIZES = [10, 25, 50, 100];

export const LIST_PAGE_SIZES_SLIDES = [12, 24, 48, 96];

export const SORT_OPTIONS = [
  { label: "oldest first", value: "asc" },
  { label: "newest first", value: "desc" }
];

export const SORT_METRICS_OPTIONS = [
  {
    label: "Meilleure rentabilité",
    value: JSON.stringify({ property: "netAssets", dir: "desc" })
  },
  {
    label: "Meilleure solvabilité",
    value: JSON.stringify({
      property: "degreeOfFinancialIndependence",
      dir: "desc"
    })
  },
  {
    label: "Meilleure liquidité",
    value: JSON.stringify({ property: "liquidityRatio", dir: "desc" })
  },
  {
    label: "Pire rentabilité",
    value: JSON.stringify({ property: "netAssets", dir: "asc" })
  },
  {
    label: "Pire solvabilité",
    value: JSON.stringify({
      property: "degreeOfFinancialIndependence",
      dir: "asc"
    })
  },
  {
    label: "Pire liquidité",
    value: JSON.stringify({ property: "liquidityRatio", dir: "asc" })
  }
];

export const SOCIETY_TYPES = [
  { value: 1, label: _("unknown") },
  { value: 2, label: _("companyNaturalPerson") },
  { value: 3, label: _("companyLegalPerson") }
];

export const ORGANIZATION_CONFIG_STATE = [
  { value: 2, label: _("configured"), color: "#62DEB0" },
  { value: 1, label: _("noBalanceImported"), color: "#FFB06A" },
  { value: 0, label: _("notConfigured"), color: "#e6140a" }
];

export const CLIENT_CRM_TYPE_FILTER = [
  {
    value: "PROSPECT",
    label: _("Prospect")
  },
  {
    value: "CLIENT",
    label: _("client")
  }
];

export const CLIENT_GROUP_CRM_FILTER = [
  {
    value: "AiSBL",
    label: _("AiSBL")
  },
  {
    value: "ASBL",
    label: _("ASBL")
  },
  {
    value: "ASBL - Consultation",
    label: _("ASBL - Consultation")
  },
  {
    value: "ASBL - Partenaire",
    label: _("ASBL - Partenaire")
  },
  {
    value: "ASBL petite entreprise",
    label: _("ASBL petite entreprise")
  },
  {
    value: "Contact",
    label: _("Contact")
  },
  {
    value: "Fondation privée",
    label: _("Fondation privée")
  },
  {
    value: "Gérant petite entreprise",
    label: _("Gérant petite entreprise")
  },
  {
    value: "Gérants",
    label: _("Gérants")
  },
  {
    value: "Indépendants",
    label: _("Indépendants")
  },
  {
    value: "Indépendants - Consultation",
    label: _("Indépendants - Consultation")
  },
  {
    value: "Indépendants petite entreprise",
    label: _("Indépendants petite entreprise")
  },
  {
    value: "Partenaire",
    label: _("Partenaire")
  },
  {
    value: "Particuliers",
    label: _("Particuliers")
  },
  {
    value: "Particuliers - Consultation",
    label: _("Particuliers - Consultation")
  },
  {
    value: "Sociétés",
    label: _("Sociétés")
  },
  {
    value: "Sociétés - Partenaire",
    label: _("Sociétés - Partenaire")
  },
  {
    value: "Sociétés petite entreprise",
    label: _("Sociétés petite entreprise")
  },
  {
    value: "Test",
    label: _("Test")
  }
];

export const BALANCE_CONFIG = {
  Kluwer: [
    {
      label: _("comparedModel"),
      value: "kluwer_compared_model"
    },
    {
      label: _("FiveYearsModel"),
      value: "kluwer_5_years_model"
    },
    {
      label: _("TwoYearsModel"),
      value: "kluwer_2_years_model"
    },
    {
      label: _("OneYearModel"),
      value: "kluwer_1_year_model"
    },
    {
      label: "Trimestriel",
      value: "kluwer_trimester_model"
    },
    {
      label: "Semestriel",
      value: "kluwer_semester_model"
    },
    {
      label: "Mensuel",
      value: "kluwer_month_model"
    }
  ],
  WinBooks: [
    {
      label: _("winbooksModel"),
      value: "winbooks_model"
    }
    /*,
    {
      label: "Semestriel",
      value: "winbooks_model_semestriel"
    }*/
    // {
    //   label: "mensuel",
    //   value: "winbooks_model_mensuel"
    // },
    // {
    //   label: "trimestriel",
    //   value: "winbooks_model_trimestriel"
    // }
  ],
  Popsy: [
    {
      label: _("OneYearModel"),
      value: "popsy_1_year_model"
    }
  ],
  Horus: [
    {
      label: _("MultipleYearsModel"),
      value: "horus_multiple_years_model"
    },
    {
      label: _("OneYearModel"),
      value: "horus_1_year_model"
    }
  ],
  Bob50: [
    {
      label: _("MultipleYearsModel"),
      value: "lhoneux_multiple_years_model"
    },
    {
      label: _("OneYearModel"),
      value: "lhoneux_1_year_model"
    }
  ]
};

export const BALANCE_MODELS_CONFIG = {
  kluwer_compared_model: {
    years: 5,
    description: _("kluwercomparedModelDescription")
  },
  kluwer_5_years_model: {
    years: 5,
    description: _("kluwerFiveYearsModelDescription")
  },
  kluwer_2_years_model: {
    years: 2,
    description: _("kluwerTwoYearsModelDescription")
  },
  kluwer_1_year_model: {
    years: 1,
    description: _("kluwerOneYearModelDescription")
  },
  winbooks_model: {
    years: 1,
    description: _("winbooksModelDescription")
  },
  popsy_1_year_model: {
    years: 1,
    description: _("winbooksModelDescription")
  },
  horus_multiple_years_model: {
    years: 0,
    description: _("multipleModelDescription")
  },
  horus_1_year_model: {
    years: 1,
    description: _("winbooksModelDescription")
  },
  kluwer_trimester_model: {
    years: 1,
    months: 12,
    description: "kluwer model trimestriel"
  },
  kluwer_semester_model: {
    years: 1,
    months: 12,
    description: "kluwer model semestriel"
  },
  kluwer_month_model: {
    years: 1,
    months: 12,
    description: "kluwer model mensuel"
  },
  lhoneux_multiple_years_model: {
    years: 0,
    description: _("multipleModelDescription")
  },
  lhoneux_1_year_model: {
    years: 1,
    description: _("winbooksModelDescription")
  }
};

export const MODEL_BALANCE_SHEET = "STANDARD";
export const MODEL_MUTATION = "MUTATION";
export const MODEL_FINANCIAL = "FINANCIAL";
export const MODEL_TREASURY = "TREASURY";
export const ANNEXES = "ANNEXES";

export const MODEL_PARENTS = {
  STANDARD: ["0_CA", "0_CP", "0_CR"],
  MUTATION: ["0_AF", "0_AC", "0_PP", "0_PC"],
  FINANCIAL: ["0_FR", "0_VAR", "0_RL", "0_RS", "0_RR"],
  TREASURY: ["0_ROB", "0_VFRNO", "0_IAI", "0_FINANCE"]
};

export const CHECKBOX_CHECKED = "ASSOCIATION_STATE_CHECKED";
export const CHECKBOX_UNCHECKED = "ASSOCIATION_STATE_UNCHECKED";
export const CHECKBOX_INDETERMINATE = "ASSOCIATION_STATE_INDETERMINATE";

export const DASHBOARD_STATUS = ["STANDARD", "CREATED"];

export const DASHBOARD_SLIDES_STATUS = [
  { label: _("all"), value: "ALL" },
  { label: _("myTemplates"), value: "MyTemplates" },
  { label: _("library"), value: "LIBRARY" }
];

export const DAYS_CALENDAR = [
  { label: _("monday"), value: "Mon" },
  { label: _("tuesday"), value: "Tue" },
  { label: _("wednesday"), value: "Wed" },
  { label: _("thursday"), value: "Thu" },
  { label: _("friday"), value: "Fri" },
  { label: _("saturday"), value: "Sat" },
  { label: _("sunday"), value: "Sun" }
];

export const SPECIAL_CARACTERES = [
  { letter: "á", code: ".\\u00e0.\\u00c0." },
  { letter: "à", code: ".\\u00e1.\\u00c1." },
  { letter: "â", code: ".\\u00e2.\\u00c2." },
  { letter: "ã", code: ".\\u00e3.\\u00c3." },
  { letter: "ä", code: ".\\u00e4.\\u00c4." },
  { letter: "å", code: ".\\u00e5.\\u00c5." },
  { letter: "æ", code: ".\\u00e6.\\u00c6." },
  { letter: "ç", code: ".\\u00e7.\\u00c7." },
  { letter: "é", code: ".\\u00e9.\\u00c9." },
  { letter: "è", code: ".\\u00e8.\\u00c9." },
  { letter: "ê", code: ".\\u00ea.\\u00ca." },
  { letter: "ë", code: ".\\u00eb.\\u00cb." },
  { letter: "í", code: ".\\u00ed.\\u00cd." },
  { letter: "ì", code: ".\\u00ec.\\u00cc." },
  { letter: "î", code: ".\\u00ee.\\u00ce." },
  { letter: "ï", code: ".\\u00ef.\\u00cf." },
  { letter: "õ", code: ".\\u00f6.\\u00d6." },
  { letter: "ó", code: ".\\u00f3.\\u00d3." },
  { letter: "ò", code: ".\\u00f2.\\u00d2." },
  { letter: "ô", code: ".\\u00f4.\\u00d4." },
  { letter: "ú", code: ".\\u00f9.\\u00d9." },
  { letter: "ù", code: ".\\u00fa.\\u00da." },
  { letter: "û", code: ".\\u00fb.\\u00db." },
  { letter: "ÿ", code: ".\\u00ff.\\u0178." },
  { letter: "ü", code: ".\\u00fc.\\u00dc." },
  { letter: "œ", code: ".\\u0153.\\u0152." },
  { letter: "õ", code: ".\\u00f5.\\u00d5." },
  { letter: "ñ", code: ".\\u00f1.\\u00d1." },
  { letter: "ï", code: ".\\u00ef.\\u00df." },
  { letter: "À", code: ".\\u00c0.\\u00e0." },
  { letter: "Á", code: ".\\u00c1.\\u00e1." },
  { letter: "Â", code: ".\\u00c2.\\u00e2." },
  { letter: "Ã", code: ".\\u00c3.\\u00e3." },
  { letter: "Ä", code: ".\\u00c4.\\u00e4." },
  { letter: "Å", code: ".\\u00c5.\\u00e5." },
  { letter: "Æ", code: ".\\u00c6.\\u00e6." },
  { letter: "Ç", code: ".\\u00c7.\\u00e7." },
  { letter: "È", code: ".\\u00c8.\\u00e8." },
  { letter: "É", code: ".\\u00c9.\\u00e9." },
  { letter: "Ê", code: ".\\u00ca.\\u00ea." },
  { letter: "Ë", code: ".\\u00cb.\\u00eb." },
  { letter: "Ì", code: ".\\u00cc.\\u00ec." },
  { letter: "Ñ", code: ".\\u00d1.\\u00f1." },
  { letter: "Ò", code: ".\\u00d2.\\u00f2." },
  { letter: "Ó", code: ".\\u00d3.\\u00f3." },
  { letter: "Ô", code: ".\\u00d4.\\u00f4." },
  { letter: "Õ", code: ".\\u00d5.\\u00f5." },
  { letter: "Ö", code: ".\\u00d6.\\u00f6." },
  { letter: "Œ", code: ".\\u0152.\\u0153." },
  { letter: "Ø", code: ".\\u00d8.\\u00f8." },
  { letter: "Ù", code: ".\\u00d9.\\u00f9." },
  { letter: "Ú", code: ".\\u00da.\\u00fa." },
  { letter: "Û", code: ".\\u00db.\\u00fb." },
  { letter: "Ü", code: ".\\u00dc.\\u00fc." },
  { letter: "Ý", code: ".\\u00dd.\\u00ffd." }
];

export const ACTIVITIES_ACTIONS = {
  SAVE_ACCOUNTING_DATES: _("exercisesConfiguration"),
  UPLOAD_BALANCE: _("importBalance"),
  SAVE_ANNEXE: _("importAnnexes"),
  SAVE_PRESENTATION: _("preparationPresention"),
  PRESENTATION_PREPARED: _("preparationPresention"),
  PRESENTATION_PRESENTED: _("preparationPresention"),
  DASHBOARD_CREATED: _("creationDashboard"),
  DASHBOARD_SHARED: _("dashboardShared"),
  SLIDE_CREATED: _("creationSlide"),
  SLIDE_SHARED: _("slideShared")
};
// used == Slide shared by another organization but it's non editable (to use only)
export const SLIDES_TABS = [
  { label: "all", value: "all" },
  { label: "created", value: "created" },
  { label: "standard", value: "standard" },
  { label: "frozen", value: "used" }
];

export const USER_ROLE_TYPES = [
  "LEGAL_REPRESENTATIVE",
  "MANAGER",
  "OFFICIAL",
  "EXTERNAL"
];

export const MODEL_TEXT_EMAILING = {
  APPOINTMENT: { title: "rendezVous", action: "sendAppointment" },
  GENERATED_LINK: { title: "presentationLink", action: "sendLink" },
  FEEDBACK: { title: "feedbackRequest", action: "sendRequest" }
};

export const USER_ROLE_TYPE_STATUS = ["ADMIN", "MANAGER"];

export const DOCUMENT_TYPE = [{ value: null, label: "all" }];
export const ROLE_TYPES = {
  // key: 'ALL', value: 'All',
  accountingRoles: [
    { key: "1ADMIN", value: "admin" },
    { key: "1EDITOR", value: "editor" }
  ],
  organizationRoles: [
    { key: "2LEGAL_REPRESENTATIVE", value: "LEGAL_REPRESENTATIVE" },
    { key: "2MANAGER", value: "MANAGER" },
    { key: "2OFFICIAL", value: "OFFICIAL" },
    { key: "2EXTERNAL", value: "EXTERNAL" }
  ]
};

export const ANNEXE_CATEGORIES = [
  { value: "1", label: "Bilan" },
  { value: "2", label: "Balance clients" },
  { value: "3", label: "Balance âgée clients" },
  { value: "4", label: "Balance Fournisseurs" },
  { value: "5", label: "Historique des clients" },
  { value: "6", label: "Historique des clients ouverts" },
  { value: "7", label: "Historique des fournisseurs" },
  { value: "8", label: "Historique des fournisseurs ouverts" },
  { value: "9", label: "Balance âgée fournisseurs" },
  { value: "10", label: "Historique des comptes généraux" },
  { value: "11", label: "Tableau d'amortissement" },
  { value: "12", label: "Historique Compte courant Administrateur/gérant" },
  { value: "13", label: "Historique compte d'attente" },
  { value: "14", label: "Relevé social annuel" },
  { value: "15", label: "Tableau de concordance sociale" },
  { value: "16", label: "Tableau de concordance TVA" },
  { value: "17", label: "DNA" },
  { value: "18", label: "Calcul d'impôt" },
  { value: "19", label: "PV Assemblée générale" }
];

export const BALANCE_MONTHS = [
  { value: 1, label: "janvier" },
  { value: 2, label: "février" },
  { value: 3, label: "mars" },
  { value: 4, label: "avril" },
  { value: 5, label: "mai" },
  { value: 6, label: "juin" },
  { value: 7, label: "juillet" },
  { value: 8, label: "aout" },
  { value: 9, label: "september" },
  { value: 10, label: "octobre" },
  { value: 11, label: "november" },
  { value: 12, label: "décembre" }
];

export const SELECT_TRIMESTRE = [
  { value: 1, label: "firstTrimester" },
  { value: 2, label: "secondTrimester" },
  { value: 3, label: "thirdTrimester" },
  { value: 4, label: "fourthTrimester" }
];

export const BALANCE_TRIMESTRE = {
  firstTrimester: [
    { value: 1, label: "janvier" },
    { value: 2, label: "février" },
    { value: 3, label: "mars" }
  ],
  secondTrimester: [
    { value: 4, label: "avril" },
    { value: 5, label: "mai" },
    { value: 6, label: "juin" }
  ],
  thirdTrimester: [
    { value: 7, label: "juillet" },
    { value: 8, label: "aout" },
    { value: 9, label: "september" }
  ],
  fourthTrimester: [
    { value: 10, label: "octobre" },
    { value: 11, label: "november" },
    { value: 12, label: "décembre" }
  ]
};

export const ACCESS_KEY_DURATION_OPTIONS = [
  { value: 1, label: "1 jour" },
  { value: 2, label: "7 jours" },
  { value: 3, label: "14 jours" },
  { value: 4, label: "30 jours" }
];

export const ACCESS_KEY_DURATION = {
  1: "+1 days",
  2: "+7 days",
  3: "+14 days",
  4: "+30 days"
};

const getIcon = icon => `/img/toolbar/${icon}.svg`;

export const getEditorToolbarConfig = (mode = "FULL", isExtraSlide = false) => {
  const toolBar = {
    options: [
      "history",
      "fontFamily",
      "fontSize",
      "blockType",
      "inline",
      "list",
      "colorPicker",
      // "image",
      "remove",
      "textAlign",
      "emoji"
    ],
    history: {
      undo: {
        icon: getIcon("undo"),
        className: "toolbar__option-custom"
      },
      redo: {
        icon: getIcon("redo"),
        className: "toolbar__option-custom"
      }
    },
    inline: {
      options: [
        "italic",
        "bold",
        "underline",
        "strikethrough",
        "superscript",
        "subscript"
      ],
      bold: {
        icon: getIcon("bold"),
        className: "toolbar__option-custom"
      },
      italic: {
        icon: getIcon("italic"),
        className: "toolbar__option-custom"
      },
      underline: {
        icon: getIcon("underline"),
        className: "toolbar__option-custom"
      },
      strikethrough: {
        icon: getIcon("strikethrough"),
        className: "toolbar__option-custom"
      },
      monospace: {
        icon: getIcon("monospace"),
        className: "toolbar__option-custom"
      },
      superscript: {
        icon: getIcon("superscript"),
        className: "toolbar__option-custom"
      },
      subscript: {
        icon: getIcon("subscript"),
        className: "toolbar__option-custom"
      }
    },
    blockType: {
      className: "toolbar__option-custom-wide",
      dropdownClassName: "toolbar__dropdown-custom"
    },
    fontSize: {
      className: "toolbar__option-custom-wide",
      options: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 30, 36, 48, 60]
    },
    list: {
      options: ["unordered", "ordered", "indent", "outdent"],
      unordered: {
        icon: getIcon("list-1"),
        className: "toolbar__option-custom"
      },
      ordered: {
        icon: getIcon("list"),
        className: "toolbar__option-custom"
      },
      indent: {
        icon: getIcon("indent"),
        className: "toolbar__option-custom"
      },
      outdent: {
        icon: getIcon("outdent"),
        className: "toolbar__option-custom"
      }
    },
    textAlign: {
      left: {
        icon: getIcon("left-align"),
        className: "toolbar__option-custom"
      },
      center: {
        icon: getIcon("center-align"),
        className: "toolbar__option-custom"
      },
      right: {
        icon: getIcon("right-align"),
        className: "toolbar__option-custom"
      },
      justify: {
        icon: getIcon("justify"),
        className: "toolbar__option-custom"
      }
    },
    fontFamily: {
      className: "toolbar__option-custom-wide",
      dropdownClassName: "toolbar__dropdown-custom",
      options: [
        "Roboto",
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana"
      ]
    },
    colorPicker: {
      icon: getIcon("dropper"),
      className: "toolbar__option-custom",
      popupClassName: "toolbar__popup-custom"
    },
    link: {
      popupClassName: "toolbar__popup-custom",
      link: {
        icon: getIcon("link"),
        className: "toolbar__option-custom"
      },
      unlink: {
        icon: getIcon("broken-link"),
        className: "toolbar__option-custom"
      }
    },
    // image: {
    //   icon: getIcon("image"),
    //   className: "toolbar__option-custom",
    //   popupClassName: "toolbar__popup-custom"
    // },
    emoji: {
      icon: getIcon("emoji"),
      className: "toolbar__option-custom",
      popupClassName: "toolbar__popup-custom"
    },
    remove: {
      icon: getIcon("eraser"),
      className: "toolbar__option-custom"
    }
  };

  // if (mode === "REDUCED") {
  //   return {
  //     ...toolBar,
  //     options: [
  //       "history",
  //       "fontFamily",
  //       "fontSize",
  //       "inline",
  //       "colorPicker",
  //       "link",
  //       "image",
  //       "remove",
  //       "emoji",
  //       "textAlign",
  //       "list"
  //     ]
  //   };
  // }
  return toolBar;
};

export const DAYS_CONFIG = [
  { label: "today", value: "today", daysToSub: 0 },
  { label: "yesterday", value: "yesterday", daysToSub: 1 },
  { label: "otherday", value: "otherday", daysToSub: 2 },
  { label: "week", value: "week", daysToSub: null }
];

export const MONTHS = [
  "JAN",
  "FEV",
  "MAR",
  "AVR",
  "MAI",
  "JUN",
  "JUL",
  "AOU",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];

export const COOKIES_DATA = [
  AUTH_COOKIE_NAME,
  "XSRF-TOKEN",
  `ttp_session_${APP_ENV}`,
  `ttp_community_${APP_ENV}`
];

export const VISIBILITY_OPTIONS = [
  { label: _("all"), value: "-1" },
  { label: _("hide"), value: "1" },
  { label: _("visible"), value: "0" }
];

export const COLLABORATOR_ROLES = {
  ALL: _("all"),
  SUPERVISOR: "SUPERVISOR",
  GD: "GD",
  GE: "GE",
  SCAN_OP: "SCAN_OP",
  SE: "SE"
};

export const COLLABORATOR_ROLE_FILTER = [
  {
    value: "",
    label: _(COLLABORATOR_ROLES.ALL)
  },
  {
    value: COLLABORATOR_ROLES.SUPERVISOR,
    label: _(COLLABORATOR_ROLES.SUPERVISOR)
  },
  {
    value: COLLABORATOR_ROLES.GD,
    label: _(COLLABORATOR_ROLES.GD)
  },
  {
    value: COLLABORATOR_ROLES.GE,
    label: _(COLLABORATOR_ROLES.GE)
  },
  {
    value: COLLABORATOR_ROLES.SCAN_OP,
    label: _(COLLABORATOR_ROLES.SCAN_OP)
  },
  {
    value: COLLABORATOR_ROLES.SE,
    label: COLLABORATOR_ROLES.SE
  }
];



// WEBPACK FOOTER //
// ./src/config/index.js